import { Phone } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#0f2334] border-t border-white/10 py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
      <div>
        <p className="font-serif text-lg font-semibold text-[#faf7f2]">
          Chesco <span className="italic text-[#e8c78f]">Local Presence</span>
        </p>
        <p className="text-sm text-[#8fa5b5] mt-1">
          Websites &amp; local SEO for Chester County, PA businesses.
        </p>
      </div>
      <a
        data-testid="footer-phone-link"
        href="tel:6104534448"
        className="inline-flex items-center gap-2 text-[#e8c78f] font-semibold hover:text-white transition-colors duration-300"
      >
        <Phone size={16} /> (610) 453-4448
      </a>
      <p className="text-xs text-[#627d98]">&copy; 2026 e2etech LLC</p>
    </div>
  </footer>
);

export default Footer;
